import { Language, Locale } from './models'

export function localizedAttribute(model, attribute, locale) {
  return model[`${attribute}_${locale}`] || model[attribute]
}

export function localeFromlanguage(language) {
  return language === Language.fr ? Locale.fr : Locale.de
}
